import type { GetOneResponseOrder } from "@classes-service-types/get-one-response-order";
import type { OrderRead } from "@classes-service-types/order-read";
import { useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import type { MaybeRef } from "vue";
import { computed, toValue } from "vue";
import ordersService from "@/services/orders.js";

interface OrderGetOneParams {
  get_canceled: boolean;
  get_archived: boolean;
  get_withdrawn: boolean;
  with_housing_show_rules: boolean;
}

export const useGetOneOrder = (
  orderId: MaybeRef<string | undefined>,
  params: MaybeRef<OrderGetOneParams> | undefined = undefined,
) => {
  const enabled = computed(() => Boolean(toValue(orderId)));
  const queryKey = computed(() => ["get-one-order-by-id", toValue(orderId)]);

  const fetchGetOne = async (): Promise<OrderRead> => {
    const orderResponse: AxiosResponse<GetOneResponseOrder> = await ordersService.getOne({
      order_id: toValue(orderId),
      payload: {},
      params,
    });
    return orderResponse.data.data.order;
  };

  return useQuery<OrderRead>({
    enabled,
    queryKey,
    queryFn: fetchGetOne,
  });
};
